import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatSortModule} from '@angular/material/sort';
import {MatTreeModule} from '@angular/material/tree';
import {
  NbActionsModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbMenuModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbThemeModule,
  NbTooltipModule,
  NbWindowModule
} from '@nebular/theme';
import {
  CheckboxPropertyComponent,
  CompoTreeComponent,
  FileUploadComponent,
  FilterCountComponent,
  InputFilterPropertyComponent,
  IntervalWrapperComponent,
  ModalMenuComponent,
  SelectFilterPropertyComponent,
  SharedModule,
  UploaderComponent
} from 'compob2b-libs';
import {environment} from '../../environments/environment';

import {ModalCatalogComponent} from './catalog/modal-catalog/modal-catalog.component';
import {LayoutComponent} from './shared/layout/layout.component';
import {ModalExcelExportComponent} from './shared/modal-excel-export/modal-excel-export.component';
import {PageLinkComponent} from './shared/page-link/page-link.component';
import {FormlyModule} from "@ngx-formly/core";
import {FilterComponent} from "./filter-component/filter.component";
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterModule} from '@angular/router'
import {TuiIcon} from '@taiga-ui/core'
import {SearchAutocompleteComponent} from './search-autocomplete/search-autocomplete.component'
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap'
import {BasketHeaderComponent} from './cart/basket-header/basket-header.component'
import {LocaleSwitcherComponent} from './shared/locale/locale-switcher.component'

@NgModule({
  imports: [
    CommonModule,
    MatTreeModule,
    MatSortModule,
    RouterModule,
    SharedModule.forRoot(environment),
    NbThemeModule.forRoot({name: 'default'}),
    NbButtonModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot({
      wrappers: [
        {name: 'interval-wrapper', component: IntervalWrapperComponent},
      ],
      types: [
        {name: 'checkbox', component: CheckboxPropertyComponent},
        {name: 'input-filter-property', component: InputFilterPropertyComponent},
        {name: 'select-filter-property', component: SelectFilterPropertyComponent},
        {name: 'select-multi-filter-property', component: SelectFilterPropertyComponent},
        {name: 'file-upload-input', component: FileUploadComponent},
      ],
      validationMessages: SharedModule.validationMessages(),
    }),
    NbLayoutModule,
    NbActionsModule,
    NbInputModule,
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbTooltipModule,
    NbCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    NbCheckboxModule,
    NbSelectModule,
    NbListModule,
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbTagModule,
    NbSpinnerModule,
    NbAutocompleteModule,
    NbTabsetModule,
    ModalCatalogComponent,
    NbMenuModule,
    NbSidebarModule,
    FilterCountComponent,
    CompoTreeComponent,
    FormlyModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    UploaderComponent,
    TuiIcon,
    NbIconModule,
    SearchAutocompleteComponent,
    ModalMenuComponent,
    BasketHeaderComponent,
    LocaleSwitcherComponent,
    LayoutComponent,
    FilterComponent,
    PageLinkComponent,
    ModalExcelExportComponent
  ],
  exports: [
    MatTreeModule,
  ]
})
export class CabinetModule {
}
